/**
 * @module enum
 */
export enum MessagePriorityEnum {
    /**
     * 默认为普通优先级
     */
    V2TIM_PRIORITY_DEFAULT,

    /**
     * 高优先级，一般用于礼物等重要消息
     */
    V2TIM_PRIORITY_HIGH,

    /**
     * 普通优先级，一般用于普通消息
     */
    V2TIM_PRIORITY_NORMAL,

    /**
     * 低优先级，一般用于点赞消息
     */
    V2TIM_PRIORITY_LOW,
}
